import {Injectable} from '@angular/core';
import {Mutation} from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root',
})
export class UpdateTerminalMutation extends Mutation {
  document = gql`
      mutation updateTerminal($id:ID!,$name: String!, $type:TerminalType!,$devices: GPIODeviceUpdateManyWithoutTerminalInput, $relaysToSwitch: RelayUpdateManyInput) {
          updateTerminal(where:{
              id:$id
          }
              data: {
                name: $name
                type:$type
                devices: $devices
                relaysToSwitch: $relaysToSwitch
              }
          ) {
              id
              name
          }
      }
  `;
}
